<div class="ml-2">
  <bpt-search
    appBlurOnSearch
    *ngIf="
      isMasterDataLoaded
    "
    class="search-component"
    [placeholder]="placeHolder"
    [advancedSearch]="true"
    [searchControls]="searchControl"
    [search]="getSearchResults"
    [advancedSearchMethod]="getAdvancedSearchResults"
  >
  </bpt-search>
</div>
<div
  *ngIf="
    hasUserSearched && isPanelHubDataAvailable && !spinnerOn" id="courseCatalogue">
  <app-panel-hub 
    #coursePanelHub
    [config]="panelHubConfig"
    [pagedData]="pagedData"
    [activeView]="currentView"
    (panelHubStateChanged)="onPanelHubEvent($event)"
    (panelEventHub)="onPanelEventHubInitialized($event)"
    (viewChanged)="onViewChanged($event)"
  >
    <!-- Default View Templates -->
    <ng-template #headerTemplate let-data="dataVar" let-viewMode="currentView">
      <div class="grid" *ngIf="viewMode === 0 || viewMode === 2">
        <div class="flex">
            <div class="overflow-ellipse flex-initial flex underline course-header font-semibold">
              <b pTooltip="{{ data.courseNumber }} {{ data.name }}">
                <a style="cursor: pointer" (click)="openCourse(data?.courseNumber)">{{ data?.courseNumber }}
                  {{ data?.name }}
                </a></b>
            </div>
            <div class="flex">
              <div class="flex-initial flex justify-content-center font-semibold icon-alignment">
              <b><i class="pi pi-circle-fill green-button " [ngClass]="calculatePhaseColor(data.status)"></i></b> &nbsp;
              {{data?.statusName}}
            </div>
            </div>
        </div>
      </div>
    </ng-template>
    
    <ng-template #contentTemplate let-data="dataVar" let-viewMode="currentView">
      <div class="grid" *ngIf="viewMode === 0">
        <div class="col-fixed" style="width: 15%">
          <div class="font-semibold mb-1">Legacy Course #</div>
          <div class="content-wrap">
            {{ data?.legacyCourseNumber }}
          </div>
        </div>
        <div class="col-fixed" style="width: 15%">
          <div class="font-semibold mb-1">Format</div>
          <div class="content-wrap">
            {{ data?.formatName}}
          </div>
        </div>
        <div class="col-fixed" style="width: 20%">
          <div class="font-semibold mb-1">Owner(s)</div>
          <ul class="list">
            <li class="content-wrap" *ngFor="let owner of data?.ownersInformation">
              <div [ngClass]="{'inActiveGroup': owner.isActive == false || owner.isTerminated === true }">{{ owner.name }}</div>
            </li>
          </ul>
        </div>
        <div class="col-fixed" style="width: 20%">
          <div class="font-semibold mb-1">eQMS Scope(s)</div>
          <ul class="list">
            <li class="content-wrap" *ngFor="let scopes of data?.eQMSScopeDisplayNames">
              {{ scopes }}
            </li>
          </ul>
        </div>
        <div class="col-fixed" style="width: 30%">
          <div class="font-semibold mb-1">Description</div>
          <div class="content-wrap block-with-text" tooltipPosition="left" pTooltip="{{ data?.description }}" tooltipStyleClass="tooltip">
            {{ data?.description }}
          </div>
        </div>
      </div>
      <div class="grid" *ngIf="viewMode === 2">
        <div class="col-fixed" style="width: 20%">
          <div class="font-semibold mb-1">eQMS Scope(s)</div>
          <ul class="list">
            <li class="content-wrap" *ngFor="let scopes of data?.eQMSScopeDisplayNames">
              {{ scopes }}
            </li>
          </ul>
        </div>
        <div class="col-fixed" style="width: 40%">
          <div class="font-semibold mb-1">Curriculum(s)</div>
          <ul class="list">
            <li class="content-wrap" *ngFor="let curriculum of data?.curriculums">
              <div class="overflow-ellipse flex-initial flex underline font-semibold">
                <b pTooltip="{{ curriculum?.curriculumScopeName }}">
                  <a style="cursor: pointer" (click)="openCurriculum(curriculum?.curriculumScopeId)">{{ curriculum?.curriculumScopeName }}</a>
                </b>
              </div> 
            </li>
          </ul>
        </div>
        <div class="col-fixed" style="width:40%">
          <div class="font-semibold mb-1">Training Item Group(s)</div>
          <ul class="list">
            <li class="content-wrap" *ngFor="let trainingItemGroup of data?.trainingGroups">
              <div class="overflow-ellipse flex-initial flex underline font-semibold">
                <b pTooltip="{{ trainingItemGroup?.trainingItemGroupNumber }} {{ trainingItemGroup?.trainingItemGroupName }}">
                  <a style="cursor: pointer" (click)="openTrainingItemGroup(trainingItemGroup?.trainingItemGroupNumber )">
                    {{ trainingItemGroup?.trainingItemGroupNumber }} {{ trainingItemGroup?.trainingItemGroupName }}
                  </a>
                </b>
              </div> 
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </app-panel-hub>
</div>
<div class = "displayCenter" 
*ngIf="(courseCatalogueSearchResult==undefined || courseCatalogueSearchResult.length == 0) && isSearch && !spinnerOn">
  <app-empty-results></app-empty-results>  
</div>

